module.exports = __webpack_public_path__ + "static/media/apple-watch.aaac2d1c.png";